export default {
  id: 147,
  title: 'Target #147 - Splash',
  url: 'https://cssbattle.dev/play/147',
  colors: ['#6592CF', '#060F55'],
  solution:
    '<a><style>body{background:#6592cf}a{position:fixed;top:225;left:325;width:200;height:30;background:#060f55;transform:rotate(45deg);border-radius:9in;box-shadow:0 120px #060f55,-65px 60px 0 10px #060f55}</style>',
}
